import Checkbox from './Checkbox'

export interface CheckboxOption {
    value: string
    label: string
    checked?: boolean
    disabled?: boolean
}

interface CheckboxesProps {
    options: CheckboxOption[]
    value: string[]
    onChange: (value: string[]) => void
    fieldId: string
    size?: 'small' | 'normal'
    gridTemplateColumns?: string
}

const Checkboxes = ({
    options,
    value,
    onChange,
    fieldId,
    size,
    gridTemplateColumns,
    ...rest
}: CheckboxesProps) => {
    return (
        <div
            style={
                gridTemplateColumns
                    ? { display: 'grid', gridTemplateColumns }
                    : {}
            }
        >
            {options.map((option) => {
                const handleChange = (evt) => {
                    const valueCopy = value ? [...value] : []
                    if (evt.target.checked) {
                        valueCopy.push(option.value)
                    } else {
                        valueCopy.splice(valueCopy.indexOf(option.value), 1)
                    }
                    onChange(valueCopy)
                }

                return (
                    <Checkbox
                        key={`${fieldId}-${option.value}`}
                        name={`${fieldId}-${option.value}`}
                        onChange={handleChange}
                        label={option.label}
                        checked={
                            option.checked ||
                            value?.some(
                                (existingValue) =>
                                    existingValue === option.value,
                            )
                        }
                        disabled={option.disabled}
                        size={size}
                        {...rest}
                    />
                )
            })}
        </div>
    )
}

export default Checkboxes
